import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/onboarding-new')({
  staticData: { requiresAuth: true },
  beforeLoad: async ({ context, location }) => {
    await context.auth.requireAuth(location);
    throw redirect({ to: '/onboarding', replace: true });
  },
});
